import { ApiEditorState } from "./types";

const state: ApiEditorState = {
  apis: {},
  contents: {},
  mappings: {},
};

export default state;
